export default "__VITE_ASSET__BWBWXQXf__"